
import * as React from 'react';
import Box from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';

import styles from "../styles/Footer.module.scss";

import Logo from '../components/Logo'
import Link from "next/link";

import ImageFooter from "../assets/images/imageFooter.svg"

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { TextField } from '@mui/material';

import facebook from '../assets/images/iconeFaceBranco.svg'
import instagram from '../assets/images/iconeInstaBranco.svg'
import linkedin from '../assets/images/iconeLinkBranco.svg'
import googleBranco from '../assets/images/googlePlayBranco.svg'
import appleBranco from '../assets/images/appleStoreBranco.svg'
import router from 'next/router';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '95%',
  maxWidth: 500,
  outline: 'none',
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 2,
  p: 4,
};

const CssTextField = styled(TextField)({
  '& input:valid + fieldset': {
    borderColor: 'green',
    borderWidth: 2,
  },
  '& input:valid:focus + fieldset': {
    borderLeftWidth: 6,
    padding: '4px !important',
  },
  '& label.Mui-focused': {
    color: '#3023BD'
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#575757',
    },
    '&:hover fieldset': {
      borderColor: '#3023BD',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#3023BD',
    },
  },
});

const Footer = () => {
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const sendContact = async (event) => {
    event.preventDefault()

    let msg = ''

    if (!event.target.name.value) {
      msg = 'O nome é um campo obrigatório'
    } else if (!event.target.email.value) {
      msg = 'O email é um campo obrigatório'
    } else if (!event.target.subject.value) {
      msg = 'O assunto é um campo obrigatório'
    } else if (!event.target.message.value) {
      msg = 'A mensagem é um campo obrigatório'
    }

    if (event.target.name.value && event.target.email.value && event.target.subject.value && event.target.message.value) {
      const data = JSON.stringify({
        nome: event.target.name.value,
        email: event.target.email.value,
        assunto: event.target.subject.value,
        mensagem: event.target.message.value
      })
      const options = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: data,
      }
      const url = `${process.env.NEXT_PUBLIC_API}contatoSite`

      const res = await fetch(url, options)

      const result = await res.json()

      toast.success(result.mensagem, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
      handleClose()
    } else {
      toast.error(msg, {
        position: "bottom-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
      handleClose()
    }
  }

  return (
    <footer id="footer" className={styles.footer}>
      <section className="grid dlg:grid-cols-5 grid-cols-2 px-8 dlg:px-0 dlg:gap-x-2 dlg:w-9/12 mx-auto">
        <div className="dlg:place-self-center dlg:col-span-1 col-span-2 dlg:h-14 2xl:mt-20 mt-8 dlg:mt-32">
          <Logo logo={'footer'} alt={'Logo da Madaseg do Rodapé'} />
        </div>
        <div className="dlg:place-self-center dlg:h-14 2xl:mt-20 mt-8 dlg:mt-32">
          <h2 className={styles.tituloFooter}>sobre nós</h2>
          <div className="flex flex-col mt-3">
            <a onClick={() => {
              router.push({
                pathname: '/sobre-nos',
              })
            }} className={styles.linkFooter}>quem somos</a>
            <a onClick={handleOpen} className={styles.linkFooter}>contato</a>
          </div>
        </div>
        <div className="dlg:place-self-center dlg:h-14 2xl:mt-20 mt-8 dlg:mt-32">
          <h2 className={styles.tituloFooter}>produtos</h2>
          <div className="flex flex-col mt-3">
            <a onClick={() => {
              router.push({
                pathname: '/seguros/residencial',
              })
            }} className={styles.linkFooter}>residencial</a>
            <a onClick={() => {
              router.push({
                pathname: '/seguros/empresarial',
              })
            }} className={styles.linkFooter}>empresarial</a>
            <a onClick={() => {
              router.push({
                pathname: '/seguros/vida',
              })
            }} className={styles.linkFooter}>vida</a>
            <a onClick={() => {
              router.push({
                pathname: '/seguros/odontologico',
              })
            }} className={styles.linkFooter}>odontológico</a>
            <a onClick={() => {
              router.push({
                pathname: '/seguros/bike',
              })
            }} className={styles.linkFooter}>bike</a>
            <a onClick={() => {
              router.push({
                pathname: '/seguros/auto',
              })
            }} className={styles.linkFooter}>auto</a>
          </div>
        </div>
        <div className="dlg:place-self-center dlg:h-14 2xl:mt-20 mt-8 dlg:mt-32">
          <h2 className={styles.tituloFooter}>gerencie</h2>
          <div className="flex flex-col mt-3">
            <a onClick={() => {
              router.push({
                pathname: '/gestao/',
              })
            }} className={styles.linkFooter}>gestão</a>
          </div>
        </div>
        <div className="dlg:place-self-center dlg:h-14 2xl:mt-20 mt-8 dlg:mt-32">
          <div className={styles.areaSocial}>
            <h2 className={styles.tituloFooter}>siga-nos nas <br /> redes sociais</h2>
            <div className='grid grid-cols-3 dlg:w-full md:w-6/12 gsm:w-10/12 w-full gap-x-2 mt-5'>
              <div>
                <Link passHref href={'https://www.facebook.com/Madaseg-107206864899857'}><a target="_blank"><img src={facebook} alt="icone facebook branco" /></a></Link>
              </div>
              <div>
                <Link passHref href={'https://www.instagram.com/madaseg_/'}><a target="_blank"><img src={instagram} alt="icone instagram branco" /></a></Link>
              </div>
              <div>
                <Link passHref href={'https://www.linkedin.com/company/madaseg'}><a target='_blank'><img src={linkedin} alt="icone linkedin branco" /></a></Link>
              </div>
            </div>
            <div className='dlg:mb-0 lsm:mb-24 mb-16'>
              <h3 className={styles.subTituloFooter}>baixe nosso app</h3>
              <Link passHref href={'https://play.google.com/store/apps/details?id=br.com.madaseg'}><a target='_blank'><img className='mt-5' src={googleBranco} alt="Google play do rodapé" /></a></Link>
              <Link passHref href={'https://apps.apple.com/br/app/madaseg/id1512022359'}><a target="_blank"><img className='mt-5' src={appleBranco} alt="Apple store do rodapé" /></a></Link>
            </div>
          </div>
        </div>
        <div className='flex md:col-span-1 col-span-2'>
          <img className={styles.imageFooter} src={ImageFooter} alt="imagem app footer" />
          <small className={styles.copyRight}>Madaseg 2022 &copy; Todos os Direitos Reservados</small>
        </div>
      </section>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            <span className={styles.tituloContato}>Contato</span>
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <form onSubmit={sendContact} noValidate className='flex flex-col justify-center'>
              <div className='mt-5'>
                <CssTextField variant="outlined" required id="name" label="Nome" />
              </div>
              <div className='mt-5'>
                <CssTextField variant="outlined" required id="email" label="Email" />
              </div>
              <div className='mt-5'>
                <CssTextField variant="outlined" required id="subject" label="Assunto" />
              </div>
              <div className='mt-5'>
                <CssTextField variant="outlined" multiline rows={2} required id="message" label="Mensagem" />
              </div>
              <div className='mt-5 text-right'>
                <button className={styles.btnEnviar} type="submit">Enviar</button>
              </div>

            </form>
          </Typography>
        </Box>
      </Modal>
      <ToastContainer />
    </footer>
  );
};

export default Footer;
